import React, { useEffect, useState } from "react";
import LoadingImg from "./loading.gif";
import axios from "../helper/axios";
import DashboardCharts from "./DashboardCharts";

export default function DashboardCard() {
  const [loading, setLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const getOrderInfo = async (pageNo) => {
    setLoading(true);
    const payload = { selectedYear };

    const res = await axios.post("/getorderinfo", payload);
    setOrderDetails(res?.data);
    setLoading(false);
  };

  useEffect(() => {
    getOrderInfo();
  }, [selectedYear]);

  return (
    <div>
      <section className="content-header">
        <h1>
          Dashboard <small>Control panel</small>
        </h1>
        <ol className="breadcrumb">
          <li>
            <a href="/#">
              <i className="fa fa-dashboard" /> Home
            </a>
          </li>
          <li className="active">Dashboard</li>
        </ol>
      </section>

      {loading && (
        <div className="text-center my-3">
          <img src={LoadingImg} width="40" alt="" />
        </div>
      )}

      <section className="content">
        <div className="row">
          <div className="col-lg-4 col-xs-6">
            <div className="small-box bg-aqua">
              <div className="inner">
                <h3>{orderDetails?.totalOrders}</h3>
                <p>Total Orders</p>
              </div>
              <div className="icon">
                <i className="ion ion-bag" />
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-xs-6">
            <div className="small-box bg-yellow">
              <div className="inner">
                <h3>{orderDetails?.totalUsers} </h3>
                <p>Total Users</p>
              </div>
              <div className="icon">
                <i className="ion ion-person-add" />
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-xs-6">
            <div className="small-box bg-red">
              <div className="inner">
                <h3>€000</h3>
                <p>Total Revenue</p>
              </div>
              <div className="icon">
                <i className="ion ion-pie-graph" />
              </div>
            </div>
          </div>
        </div>

        <DashboardCharts
          orderDetails={{ orderDetails }}
          setSelectedYear={setSelectedYear}
          selectedYear={selectedYear}
        />
      </section>
    </div>
  );
}
